import ScriptWorkspace from '../common/ScriptWorkspace';

export default function KOLScriptDetail() {
  return <ScriptWorkspace scriptsIndexPath="/kol/scripts" breadcrumbScriptsLabel="Scripts" />;
}
